const CACHE_DIR_NAME = 'ai_outpatient_attachments';

let _cacheDirs = {};

export function cacheDir(resource, resourceSubDir) {
  return Promise.resolve('not available on web');
}

export function clearCache() {
  localStorage.clear();
  return Promise.resolve();
}
